import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About Me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Know Me More
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Hi, I'm{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Justin
              </span>
            </h2>
            <p className="text-3">
              I build the connections between systems that were never designed
              to talk to each other. Nine of my twenty-three years have gone
              into Epicor ERP integrations across versions 9, 10 and Kinetic, on
              premises and in the cloud &mdash; BPMs, BAQs, Kinetic Functions,
              Application Studio, and tracing business objects down to the C#
              API methods underneath when the documentation runs out.
            </p>
            <p className="text-3">
              I wrote an open-source .NET SDK for the Epicor Kinetic REST API,
              because every integration I built was re-solving the same problem:
              strongly-typed async access to business objects, queries and
              functions, with error handling that tells you whether a failure
              happened before or after the commit boundary. It's on GitHub under
              Apache-2.0.
            </p>
            <p className="text-3">
              Before ERP I spent years in full-stack web &mdash; React, Angular,
              Node, .NET MVC &mdash; and before that in media analytics, working
              with Nielsen ratings data to qualify audience reach. That
              background keeps coming back: most of what I do now is large-scale
              order and campaign analysis, and knowing how to interrogate a
              dataset honestly matters more than knowing the syntax.
            </p>
            <p className="text-3">
              Outside of work I build RFID and tracking integrations, and a
              multi-tenant SaaS product for homeschool administration. I'm
              usually trying to find the thing my job needs that nobody has
              asked for yet.
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  23
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Years of <span className="fw-700">Experience</span>
              </h3>
              <img
                src="images/hacker-glider.png"
                alt="hacker glider"
                height="40px"
              />
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Name:</p>
            <p className="text-4 text-dark fw-600 mb-0">Justin Grant</p>
          </div>
          <div className="col-6 col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Email:</p>
            <p className="text-4 fw-600 mb-0">
              <a className="link-dark" href="mailto:justintroygrant@gmail.com">
                justintroygrant@gmail.com
              </a>
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <p className="text-muted fw-500 mb-0">From:</p>
            <p className="text-4 text-dark fw-600 mb-0">
              San Marcos, California
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
